import type { AddressFieldName } from "./AddressField";

export type AddressLayoutVariant = "pairedRows" | "stacked";

export interface AddressFieldLayoutConfig {
  pairedRows: AddressFieldName[][];
  stacked: AddressFieldName[];
}

export const DEFAULT_ADDRESS_FIELD_LAYOUT_CONFIG: AddressFieldLayoutConfig = {
  pairedRows: [
    ["addressLine1", "addressLine2"],
    ["addressLine3", "town"],
    ["county", "country"],
  ],
  stacked: ["addressLine1", "addressLine2", "addressLine3", "town", "county", "country"],
};

export const DEFAULT_ADDRESS_REQUIRED_FIELDS: AddressFieldName[] = ["addressLine1"];
